function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uD83C\\uDF6A",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "index-desktop-copy-6",
  transform: "translate(-796.000000, -942.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy-4",
  transform: "translate(797.000000, 942.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun_Watch_2218663",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.6625775,7.10542736e-15 L5.42832099,7.10542736e-15 C4.99932906,7.10542736e-15 4.65156239,0.345167637 4.65156239,0.770953496 L4.65156239,12.7424273 C1.72415284,15.0909207 0.0161614964,18.6216515 0.000110953724,22.3575965 C-0.0157145287,26.0935415 1.66209102,29.6385015 4.56935803,32.0115157 L4.73880015,44.1054632 C4.7446874,44.5270941 5.0907122,44.8658777 5.51555874,44.8658777 L5.52655765,44.8658777 L19.7592918,44.6659849 C20.1881514,44.6599974 20.530957,44.3101488 20.5250514,43.8844925 L20.3603786,32.1313064 C23.3350976,29.7859169 25.0753456,26.2263367 25.0908079,22.4556866 C25.1060652,18.6850366 23.3948736,15.1116062 20.4393594,12.7424196 L20.4393594,0.770953496 C20.4393594,0.566479909 20.3575194,0.370381365 20.2118439,0.225798874 C20.0661683,0.0812163822 19.8685908,7.10542736e-15 19.6625775,7.10542736e-15 Z M6.20507958,1.54190699 L18.885819,1.54190699 L18.885819,11.681711 C14.9767193,9.38095829 10.1141792,9.38095829 6.20507958,11.681711 L6.20507958,1.54190699 Z M18.960916,43.1350023 L6.28131844,43.3130926 L6.13827834,33.0930323 C10.033375,35.4187932 14.8968221,35.4492169 18.821146,33.1723712 L18.960916,43.1350023 Z M19.3943473,30.9259515 C19.1920298,30.9743248 19.0186255,31.1030821 18.9147532,31.2820626 C15.3356027,33.8570655 10.5468484,34.041251 6.77765874,31.7488805 C3.00846903,29.4565101 0.999546393,25.138069 1.68604567,20.8037715 L12.3440513,23.6525911 C12.4764969,23.6877262 12.6159163,23.6877262 12.7483619,23.6525911 L23.4048529,20.8037715 C24.0175966,24.6501511 22.4826807,28.5241233 19.3943317,30.9259206 L19.3943473,30.9259515 Z M23.0754062,19.2946454 L12.546226,22.1095817 L2.01554667,19.2945915 C3.40070538,14.6694754 7.68401753,11.4980435 12.5454705,11.4980435 C17.4069235,11.4980435 21.6902215,14.6695155 23.0754062,19.2946377 L23.0754062,19.2946454 Z",
  id: "Shape",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  stroke: "#AEAEAE",
  fill: "#FFFFFF",
  cx: 12.469697,
  cy: 22.1763098,
  rx: 12.4090909,
  ry: 12.3846154
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#AEAEAE",
  x: 11,
  y: 17,
  width: 2,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2547809,21.2186662 C14.730816,21.2206439 15.1161154,21.6062702 15.1176894,22.0823067 L15.1379048,28.1960388 C15.1394638,28.6675101 14.7585246,29.0509768 14.2870534,29.0525358 C14.2849303,29.0525428 14.2828071,29.0525419 14.280684,29.0525331 C13.804649,29.0505553 13.4193495,28.6649291 13.4177755,28.1888925 L13.3975601,22.0751604 C13.3960011,21.6036892 13.7769403,21.2202224 14.2484115,21.2186635 C14.2505347,21.2186565 14.2526578,21.2186574 14.2547809,21.2186662 Z",
  id: "Rectangle-Copy",
  fill: "#AEAEAE",
  transform: "translate(14.267732, 25.135600) rotate(-40.000000) translate(-14.267732, -25.135600) "
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#AEAEAE",
  x: 25,
  y: 20,
  width: 2,
  height: 5,
  rx: 1
}))));
function SvgWatchIconStrap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "45px",
    viewBox: "0 0 28 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3 Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatchIconStrap);
export default __webpack_public_path__ + "static/media/watch-icon-strap.2ca57b04b2fa03920265e86bdf31af84.svg";
export { ForwardRef as ReactComponent };